import { Role } from '@/api/types'

export default [
    {
        name: 'marketplace',
        path: '/marketplace',
        redirect: { name: 'marketplace_list' },
        meta: {
            anonymous: true,
            showSidebar: false,
            showScrollbar: false,
        },
        component: () => import(/* webpackChunkName: "marketplace" */ '../../views/Marketplace/Marketplace.vue'),
        children: [
            {
                name: 'marketplace_list',
                path: '',
                meta: {
                    requiredRole: Role.EMPLOYEE,
                    noBackground: false,
                },
                component: () => import(/* webpackChunkName: "marketplace_list" */ '../../views/Marketplace/List.vue'),
            },
            {
                name: 'marketplace_activate_flow',
                path: 'activate-flow',
                meta: {
                    anonymous: true,
                    showSidebar: false,
                    showScrollbar: false,
                },
                component: () => import(/* webpackChunkName: "marketplace_activate_flow" */ '../../views/Marketplace/ActivateFlow.vue'),
            },
            {
                name: 'marketplace_detail',
                path: ':offerId',
                meta: {
                    requiredRole: Role.EMPLOYEE,
                    parent: 'marketplace_list',
                },
                props: true,
                component: () => import(/* webpackChunkName: "marketplace_detail" */ '../../views/Marketplace/Detail.vue'),
            },
        ],
    },
]
